import { z } from "zod";

const builderReferenceSchema = z.object({
  "@type": z.literal("@builder.io/core:Reference"),
  id: z.string(),
  model: z.literal("sob-questions"),
  value: z.any().optional(),
});

const sobQuestionScreenSchema = z.object({
  title: z.string(),
  description: z.string(),
});

const sobConsentCaptureQuestionSchema = z.object({
  marketingMailConsentId: z.string(),
  title: z.string(),
  description: z.string(),
});

const answerSchema = z.object({
  id: z.string(),
  title: z.string(),
  referenceName: z.string(),
  subtitle: z.string().optional(),
  localTranslation: z.string(),
});

const questionDetailsSchema = z.object({
  id: z.string(),
  title: z.string(),
});

const questionSchema = z.object({
  onAnswerId: z.string().optional(),
  question: questionDetailsSchema,
  possibleAnswers: z.array(answerSchema),
  indicatorOverrideLabel: z.string().optional(),
  image: z.string().optional(),
  alt: z.string().optional(),
});

const consentCaptureSchema = z.object({
  marketingMailConsentId: z.string(),
  title: z.string(),
  description: z.string(),
});

const questionScreenSchema = z.object({
  title: z.string(),
  description: z.string(),
});

const finalScreenSchema = z.object({
  title: z.string(),
  description: z.string().optional(),
  topic: z.string().optional(),
});

const quizQuestionPayloadSchema = z.object({
  question_id: z.string(),
  reference_name: z.string(),
  local_translation: z.string(),
  type: z.string(),
});

const quizAnswerPayloadSchema = quizQuestionPayloadSchema.extend({
  answer_id: z.string(),
});

const quizDataSchema = z.object({
  answerDimensions: z.object({
    entity: z.string(),
    payload: z.array(quizAnswerPayloadSchema),
  }),
  questionDimensions: z.object({
    entity: z.string(),
    payload: z.array(quizQuestionPayloadSchema),
  }),
  questionScreen: questionScreenSchema,
  consentCaptureQuestion: consentCaptureSchema,
  finalScreen: finalScreenSchema,
  quizTransitions: z.array(questionSchema),
  uuid: z.string(),
  type: z.string(),
});

const sobDisabledSchema = z.object({
  enabled: z.literal(false),
  questions: builderReferenceSchema.optional(),
  questionScreen: sobQuestionScreenSchema.optional(),
  consentCaptureQuestion: sobConsentCaptureQuestionSchema.optional(),
  finalScreen: sobQuestionScreenSchema.optional(),
  data: quizDataSchema.optional(),
});

const sobEnabledSchema = z.object({
  enabled: z.literal(true),
  questions: builderReferenceSchema.optional(),
  questionScreen: sobQuestionScreenSchema.optional(),
  consentCaptureQuestion: sobConsentCaptureQuestionSchema.optional(),
  finalScreen: sobQuestionScreenSchema.optional(),
  data: quizDataSchema.optional(),
});

export const sobSchema = z.discriminatedUnion("enabled", [sobDisabledSchema, sobEnabledSchema]);
